var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "white",
    stroke: "#889BD8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2979 22.501L28.4473 29.4814L28.6572 30.167H11.3438L11.5527 29.4795L13.7031 22.501H26.2979ZM13.8389 23.1865L11.9932 29.1865L11.7939 29.834H28.2021L28.0029 29.1875L26.1621 23.1875L26.0527 22.834H13.9473L13.8389 23.1865ZM20 9.83398C21.2819 9.83398 22.5115 10.3436 23.418 11.25C24.3242 12.1563 24.8339 13.3853 24.834 14.667C24.834 15.9489 24.3244 17.1785 23.418 18.085C22.5115 18.9914 21.2819 19.501 20 19.501C18.7183 19.5009 17.4893 18.9912 16.583 18.085C15.6766 17.1785 15.167 15.9489 15.167 14.667C15.1671 13.3852 15.6767 12.1563 16.583 11.25C17.4894 10.3437 18.7182 9.83407 20 9.83398ZM20 10.167C19.4092 10.167 18.8242 10.2837 18.2783 10.5098C17.7324 10.7359 17.2362 11.0675 16.8184 11.4854C16.4005 11.9032 16.0689 12.3993 15.8428 12.9453C15.6167 13.4912 15.5 14.0762 15.5 14.667C15.5 15.2579 15.6166 15.8437 15.8428 16.3896C16.0689 16.9355 16.4005 17.4318 16.8184 17.8496C17.2362 18.2674 17.7324 18.5991 18.2783 18.8252C18.8241 19.0512 19.4092 19.1669 20 19.167C20.5909 19.167 21.1767 19.0513 21.7227 18.8252C22.2686 18.599 22.7648 18.2675 23.1826 17.8496C23.6005 17.4318 23.9321 16.9356 24.1582 16.3896C24.3843 15.8437 24.5 15.2579 24.5 14.667C24.5 14.0762 24.3843 13.4911 24.1582 12.9453C23.9321 12.3994 23.6004 11.9032 23.1826 11.4854C22.7648 11.0675 22.2685 10.7359 21.7227 10.5098C21.1767 10.2836 20.5909 10.167 20 10.167Z",
    fill: "#1D1F2A",
    stroke: "#1D1F2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAvatar);
export default __webpack_public_path__ + "static/media/user-avatar.edfa19935848e627dafa42344a8564af.svg";
export { ForwardRef as ReactComponent };